import React, { useRef } from 'react'
import cx from 'classnames'
import { useZinaImage } from 'zina'
import { useDevice } from 'device'

import s from './HeroMediaBlock.scss'


type ImageProps = {
  className?: string
  src: string
  height: number
}

const Image: React.FC<ImageProps> = ({ className, src, height }) => {
  const { isBot } = useDevice()
  const nodeRef = useRef()
  const { zinaSrc } = useZinaImage({ nodeRef, src, skip: isBot })
  const finalSrc = isBot ? src : zinaSrc

  const style = {
    backgroundImage: `url(${finalSrc})`,
    height: `${height}rem`,
  }

  return (
    <div
      ref={nodeRef}
      className={cx(className, 'bg-light-beige', s.image)}
      style={style}
    />
  )
}

type HeroMediaBlockProps = {
  className?: string
  wideMT?: boolean
  wideMB?: boolean
  'data-testid'?: string
}

type HeroMediaBlockComponent = React.CFC<HeroMediaBlockProps> & {
  Image: React.FunctionComponent<ImageProps>
}

const HeroMediaBlock: HeroMediaBlockComponent = (props) => {
  const { children, className, wideMT = true, wideMB = false, 'data-testid': dataTestId } = props

  const rootClassName = cx(className, 'mx-auto max-w-1440', {
    [s.wideMT]: wideMT,
    [s.wideMB]: wideMB,
  })

  return (
    <div
      className={rootClassName}
      data-testid={dataTestId}
    >
      {children}
    </div>
  )
}

HeroMediaBlock.Image = Image


export default HeroMediaBlock
